











import useBreadcrumb from '@/composables/useBreadcrumb'
import { useRouter } from '@u3u/vue-hooks'
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'Breadcrumb',

  setup() {
    const { router } = useRouter()

    const { routes } = useBreadcrumb()
    const isShowed = computed(() => {
      return routes.value.length > 1
    })

    const navigateBack = () => {
      router.push(routes.value[routes.value.length - 2])
    }

    return {
      isShowed,
      navigateBack
    }
  }
})
